// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'sales-credit-memo.page.title': 'Sales Credit Memos',
    'sales-credit-memo.page.search_results': 'Search Results',
    'sales-credit-memo.page.create.title': 'New Credit Memo',
    'sales-credit-memo.page.search.title': 'Find Credit Memos',
    'sales-credit-memo.page.edit.title': 'Edit Credit Memo',
    'sales-credit-memo.page.all': 'All',

    'sales-credit-memo.button.cancel': 'Cancel',
    'sales-credit-memo.button.select': 'Select',
    'sales-credit-memo.button.find': 'Find Credit Memos',
    'sales-credit-memo.button.search': 'Apply',
    'sales-credit-memo.button.create': 'Issue Memo',
    'sales-credit-memo.button.draft': 'Save as Draft',
    'sales-credit-memo.button.pro_forma': 'Save as Pro Forma',
    'sales-credit-memo.button.print': 'Print',
    'sales-credit-memo.button.email': 'Email',
    'sales-credit-memo.button.send_email': 'Send Email',
    'sales-credit-memo.button.new': 'New Credit Memo',
    'sales-credit-memo.button.cancel_draft': 'Cancel Draft',
    'sales-credit-memo.button.void': 'Void Credit Memo',
    'sales-credit-memo.button.rollback': 'Rollback Credit Memo',
    'sales-credit-memo.button.save': 'Save Changes',
    'sales-credit-memo.button.delete': 'Permanently Delete',
    'sales-credit-memo.button.edit': 'Edit',
    'sales-credit-memo.button.restore': 'Restore',
    'sales-credit-memo.button.refund': 'Refund',
    'sales-credit-memo.button.reset': 'Reset',
    'sales-credit-memo.button.record_payment': 'Record Payment',
    'sales-credit-memo.button.discount': 'Show discount',

    'sales-credit-memo.placeholder.search': 'Search credit memos',
    'sales-credit-memo.placeholder.search_items': 'Search items',

    'sales-credit-memo.message.no_change': 'This credit memo has not changed since it was created.',

    'sales-credit-memo.link.create_first_credit_memo': 'Click here to create your first credit memo',
    'sales-credit-memo.link.credit_memos': ' Return to Credit Memos',
    'sales-credit-memo.link.retry': 'Click here to retry',

    'sales-credit-memo.checkbox.all': 'Check All',
    'sales-credit-memo.checkbox.actions_label': 'with selected',

    'sales-credit-memo.label.items': 'Credit Memo Items',
    'sales-credit-memo.label.recent': 'Recent',
    'sales-credit-memo.label.popular': 'Popular',
    'sales-credit-memo.label.date': 'Date',
    'sales-credit-memo.label.item': 'Item',
    'sales-credit-memo.label.return': 'Return',
    'sales-credit-memo.label.quantity': 'Quantity',
    'sales-credit-memo.label.unit_cost': 'Unit Cost',
    'sales-credit-memo.label.total': 'Total',
    'sales-credit-memo.label.tax_total': 'Tax Total',
    'sales-credit-memo.label.grand_total': 'Grand Total',
    'sales-credit-memo.label.sub_total': 'Subtotal',
    'sales-credit-memo.label.discount': 'Discount',
    'sales-credit-memo.label.bill_to': 'Bill To',
    'sales-credit-memo.label.balance': 'Balance',
    'sales-credit-memo.label.subject': 'Subject',
    'sales-credit-memo.label.to': 'To',
    'sales-credit-memo.label.message': 'Message',
    'sales-credit-memo.label.no_items': 'No items found',
    'sales-credit-memo.label.void_reason': 'Reason for voiding credit memo',
    'sales-credit-memo.label.cancel_reason': 'Reason for canceling credit memo',
    'sales-credit-memo.label.refund_reason': 'Reason for refunding credit memo',
    'sales-credit-memo.label.rollback_reason': 'Reason for rolling back credit memo',

    'sales-credit-memo.label.sales_credit_memo_number': 'Credit Memo No',
    'sales-credit-memo.label.issue_credit': 'Give store credit?',

    'sales-credit-memo.label.credit_memo': 'Credit Memo',

    'sales-credit-memo.label.title': 'Title',
    'sales-credit-memo.label.refunded_on': 'Refund On',

    'sales-credit-memo.label.from__transaction_date': 'From transaction date',
    'sales-credit-memo.label.to__transaction_date': 'To transaction date',
    'sales-credit-memo.label.transaction_date': 'Credit Memo Date',

    'sales-credit-memo.label.printed_at': 'Printed At',
    'sales-credit-memo.label.opened_at': 'Opened At',
    'sales-credit-memo.label.paid_at': 'Paid At',

    'sales-credit-memo.label.bill_to_entity_name': 'Bill To',
    'sales-credit-memo.label.bill_to_contact_name': 'Bill To Contact',
    'sales-credit-memo.label.bill_to_address': 'Bill To Address',
    'sales-credit-memo.label.currency_name': 'Currency',
    'sales-credit-memo.label.currency_sub_total_in_cents': 'Subtotal',
    'sales-credit-memo.label.currency_discount_total_in_cents': 'Discount Total',
    'sales-credit-memo.label.currency_tax_total_in_cents': 'Tax Total',
    'sales-credit-memo.label.currency_grand_total_in_cents': 'Grand Total',
    'sales-credit-memo.label.currency_balance_owing_in_cents': 'Balance Owing',

    'sales-credit-memo.label.sold_by': 'Sales Person',
    'sales-credit-memo.label.public_customer_message': 'Public Customer Message',
    'sales-credit-memo.label.private_note': 'Private Note',

    'sales-credit-memo.label.created_at': 'Created on',
    'sales-credit-memo.label.status': 'Status',

    'sales-credit-memo.sort.field_label': 'Field',
    'sales-credit-memo.sort.direction_label': 'Direction',
    'sales-credit-memo.sort.direction_ascending': 'Ascending',
    'sales-credit-memo.sort.direction_descending': 'Descending',

    'sales-credit-memo.modal.title.credit_memo_void': 'Void Credit Memo',
    'sales-credit-memo.modal.title.credit_memo_cancel': 'Cancel Draft Credit Memo',
    'sales-credit-memo.modal.title.credit_memo_rollback': 'Rollback Credit Memo',
    'sales-credit-memo.modal.title.credit_memo_refund': 'Refund Credit Memo',
    'sales-credit-memo.modal.title.credit_memo_restore': 'Restore Credit Memo',

    'sales-credit-memo.modal.message.credit_memo_cancel': 'Are you sure that you want to cancel this draft? This action cannot be undone.| Are you sure that you want to cancel these drafts? This action cannot be undone.',
    'sales-credit-memo.modal.message.credit_memo_void':
        'Are you sure that you want to void this credit memo? This action cannot be undone and a credit note will be issued for payments. | Are you sure that you want to void these credit memos? This action cannot be undone and a credit note will be issued for payments.',
    'sales-credit-memo.modal.message.credit_memo_rollback': 'Are you sure that you want to rollback this credit memo? This action cannot be undone. | Are you sure that you want to void these credit memos? This action cannot be undone',
    'sales-credit-memo.modal.message.credit_memo_restore': 'Are you sure that you want to restore this credit memo? | Are you sure that you want to restore these credit memos?',
    'sales-credit-memo.modal.message.credit_memo_refund': 'Are you sure that you want to refund this credit memo? | Are you sure that you want to refund these credit memos?',

    'sales-credit-memo.success.message.credit_memo_created': 'Your credit memo has been created',
    'sales-credit-memo.success.message.credit_memo_updated': 'Your credit memo has been updated',
    'sales-credit-memo.success.message.credit_memo_cancelled': 'Your draft credit memo has been cancelled',
    'sales-credit-memo.success.message.credit_memo_voided': 'Your credit memo has been voided',
    'sales-credit-memo.success.message.credit_memo_rolled_back': 'Your credit memo has been rolled back',
    'sales-credit-memo.success.message.credit_memo_restored': 'Your credit memo has been restored | All selected credit memos were restored',
    'sales-credit-memo.success.message.credit_memo_refunded': 'Your credit memo has been refunded | All selected credit memos were refunded',
    'sales-credit-memo.success.message.credit_memo_deleted': 'Your credit memo has been permanently deleted | All selected credit memos were permanently deleted',

    'sales-credit-memo.error.message.credit_memo_deleted': 'This credit memo was already permanently deleted | These credit memos were already permanently deleted',
    'sales-credit-memo.error.message.credit_memo_restored': 'This credit memo was already restored | These credit memos were already restored',
    'sales-credit-memo.error.message.error_loading_page': 'Sorry, there was an error loading sales-credit-memo.| Sorry, there was an error loading credit memos.',

    'sales-credit-memo.info.message.start_from_invoice': 'To issue a credit memo, open the invoice and choose Refund.',
};
